// extracted by mini-css-extract-plugin
export default {"wrapper":"TableLoader_wrapper__6WykX","text":"TableLoader_text__iZgBn","loader":"TableLoader_loader__ZzA1T","rotation":"TableLoader_rotation__YlIsz"};